const CLOUDFRONT_HOST = process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST;

export enum VisualSearchEntryType {
  CAMERA_ICON = 'camera_icon',
}

export const VISUAL_SEARCH_MODAL_TRACKING_ID = 'VisualSearchModal';
export const VISUAL_SEARCH_BANNER_TRACKING_ID = 'VisualSearchBanner';

export const VISUAL_SEARCH_BANNER_DISMISSED_KEY = 'visualSearchBannerDismissed';

export const VISUAL_SEARCH_PHOTO_IMAGE = `${CLOUDFRONT_HOST}/web/assets/visualSearch/two-friends-walking.webp`;
export const VISUAL_SEARCH_LISTING_IMAGE = `${CLOUDFRONT_HOST}/web/assets/visualSearch/striped-shirt.webp`;
export const VISUAL_SEARCH_BANNER_IMAGE = `${CLOUDFRONT_HOST}/web/assets/visualSearch/phone-cameras.webp`;
